import { render, staticRenderFns } from "./BusinessMenuDropdown.vue?vue&type=template&id=1c95e979&scoped=true&"
import script from "./BusinessMenuDropdown.vue?vue&type=script&lang=ts&"
export * from "./BusinessMenuDropdown.vue?vue&type=script&lang=ts&"
import style0 from "./BusinessMenuDropdown.vue?vue&type=style&index=0&id=1c95e979&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c95e979",
  null
  
)

export default component.exports